import { render, staticRenderFns } from "./EmptyCard.vue?vue&type=template&id=46be23c4&scoped=true&"
import script from "./EmptyCard.vue?vue&type=script&lang=js&"
export * from "./EmptyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46be23c4",
  null
  
)

export default component.exports